var mentions_default = {
  "mention": "_3sUlC",
  "mentionViewer": "_9zptQ",
  "cursorDefault": "_0foUh",
  "cursorPointer": "EfjrO"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
